import _ from 'underscore';
import { dataLengths } from './data-persistance-enum';

/**
 *  Get Minimum Supported Day
 * @param {object} reportSchema - The report object model
 * @param {string} timeGrain - current timeGrain
 * @param {CivilDate} today today as a civildate
 * @param {warningMessage} warningMessage - optional parameter to get message instead of day
 * @returns {CivilDate} - a civilDateTime of minmium support
 */
export const getMinimumSupported = (reportSchema, timeGrain, today, warningMessage) => {
  const dataRetentionMap = reportSchema.DataRetention;
  const dataRetention = dataRetentionMap[timeGrain];

  switch (dataRetention) {
    case dataLengths['14d']:
      return warningMessage ?
        _TL_('Based on the unit of time that you selected, this report will only contain data up to last 14 days.') :
        today.plus({ days: -15 });
    case dataLengths['30d']:
      return warningMessage ?
        _TL_('Based on the unit of time that you selected, this report will only contain data up to last 30 days.') :
        today.plus({ days: -30 });
    case dataLengths['1m']:
      return warningMessage ?
        _TL_('Based on the unit of time that you selected, this report will only contain data up to last 1 month.') :
        today.plus({ months: -1 });
    case dataLengths['90d']:
      return warningMessage ?
        _TL_('Based on the unit of time that you selected, this report will only contain data up to last 90 days.') :
        today.plus({ days: -90 });
    case dataLengths['2m']:
      return warningMessage ?
        _TL_('Based on the unit of time that you selected, this report will only contain data up to last 2 months.') :
        today.plus({ months: -2 });
    case dataLengths['6m']:
      return warningMessage ?
        _TL_('Based on the unit of time that you selected, this report will only contain data up to last 6 months.') :
        today.plus({ months: -6 });
    case dataLengths['12m']:
      return warningMessage ?
        _TL_('Based on the unit of time that you selected, this report will only contain data up to last 12 months.') :
        today.plus({ months: -12 });
    case dataLengths['24m']:
      return warningMessage ?
        _TL_('Based on the unit of time that you selected, this report will only contain data up to last 24 months.') :
        today.plus({ months: -24 });
    case dataLengths['36m']:
      return warningMessage ?
        _TL_('Based on the unit of time that you selected, this report will only contain data up to last 36 months.') :
        today.plus({ months: -36 });
    default:
      _.defer(() => { throw new RangeError(`getMinimumSupported - dataRetention: ${dataRetention} timeGrain: ${timeGrain} not found on switch statement`); });
      return warningMessage ?
        _TL_('Based on the unit of time that you selected, this report will only contain data up to last 36 months.') :
        today.plus({ months: -36 });
  }
};

/**
 *  Get Minimum Supported Day
 * @param {object} reportSchema - The report object model
 * @param {string} timeGrain - current timeGrain
 * @param {CivilDate} today today as a civildate
 * @returns {CivilDate} - a civilDateTime of minmium support
 */
export const getMinimumSupportedDay =
  (reportSchema, timeGrain, today) => getMinimumSupported(reportSchema, timeGrain, today, false);

/**
 *  Get Minimum Supported warningMessage
 * @param {object} reportSchema - The report object model
 * @param {string} timeGrain - current timeGrain
 * @param {CivilDate} today today as a civildate
 * @returns {CivilDate} - a civilDateTime of minmium support
 */
export const getMinimumSupportedWarning =
  (reportSchema, timeGrain, today) => getMinimumSupported(reportSchema, timeGrain, today, true);
